var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-3d-container"},[_c('div',{staticClass:"carousel-background"}),_c('div',{staticClass:"carousel-3d-slider"},[_vm._t("default")],2),(_vm.controls)?_c('controls',{attrs:{"next-html":_vm.controlsNextHtml,"prev-html":_vm.controlsPrevHtml,"width":_vm.controlsWidth,"height":_vm.controlsHeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }